// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".grid-container[data-v-45963314]{position:relative}.grid-line[data-v-45963314]{position:absolute;top:0;left:0;right:0;bottom:0;background:red}", ""]);
// Exports
module.exports = exports;
